<template>
  <div class="box">
    <div class="box-header">
      <custom :total="totals" />
    </div>
    <table class="table">
      <thead>
        <tr>
          <th class="is-xs">No.</th>
          <th class="is-md">Article Type</th>
          <th>Article Title</th>
          <th class="is-sxm">Posted Date</th>
          <th class="is-sm">Setting</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(b, idx) in articles" :key="idx">
          <td>{{ idx + 1 }}</td>
          <td>{{ b.BlogTypeId.map((i) => i.name).join(", ") }}</td>
          <td>{{ b.title }}</td>
          <td>{{ b.createdAt | moment }}</td>
          <td>
            <div class="icon-group">
              <span
                @click="
                  $router.push({ name: 'add-article', query: { id: b._id } })
                "
                ><i class="fad fa-cog"></i
              ></span>
              <span @click="deleteArticle(b._id)" class="alert"
                ><i class="fad fa-trash"></i
              ></span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import custom from "../Pagination/customPagination";

import moment from "moment";
import { GET_ARTICLE, DELETE_ARTICLE } from "@/graphql/articles/articles";
import { apolloClient } from "@/services/apollo-client";
export default {
  components: { custom },
  data: () => ({
    articles: [],
    totals: null,
    isLoading: false,
  }),
  filters: {
    moment: function (date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
  methods: {
    async queryArticle() {
      this.isLoading = true;
      const res = await apolloClient.query({
        query: GET_ARTICLE,
        variables: {
          page: parseInt(this.$route.query.q),
          perPage: parseInt(this.$route.query.p),
          search: this.$route.query.s,
        },
      });
      let allArticle = res.data.getBlog;
      this.articles = allArticle.blog;
      this.totals = allArticle.totals;
      this.isLoading = false;
    },
    async deleteArticle(i) {
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;

      await apolloClient.mutate({
        mutation: DELETE_ARTICLE,
        variables: {
          blogId: i,
        },
      });
      window.location.reload();
    },
  },
  watch: {
    "$route.query": {
      handler(val) {
        if (val) {
          this.queryArticle();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  // create the array of items
  created() {
    this.queryArticle();
  },
};
</script>

<style lang="scss" scoped>
.image-container {
  height: 120px;
  width: auto;
  overflow: hidden;
  img {
    height: 120px;
  }
}
</style>